import { render, staticRenderFns } from "./ArtiklKartica.vue?vue&type=template&id=5ed4ff0b"
import script from "./ArtiklKartica.vue?vue&type=script&lang=js"
export * from "./ArtiklKartica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports